import { render, staticRenderFns } from "./OrderBarrel.vue?vue&type=template&id=ca828ad2&"
import script from "./OrderBarrel.vue?vue&type=script&lang=js&"
export * from "./OrderBarrel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports